import type React from "react";
import { useAppSelector } from "../../hooks/redux-hooks";
import AppointmentSelectionModal from "../TransferButton/AppointmentSelectionModal";
import MFACodeModal from "../TransferButton/MFACodeModal";
import { useTransfer } from "../TransferButton/TransferContext";

// Mounts the appointment / note-template / MFA modals at the app shell level
// so the context state survives navigation. Modals only render while the
// clinician is on the target note's page — elsewhere the banner's "Go to note"
// CTA brings them here, and the modal pops once they land.
const TransferModalsHost: React.FC = () => {
  const {
    activeJob,
    appointmentOptions,
    showAppointmentModal,
    isSelectingAppointment,
    isNoteTypeSelection,
    showMFAModal,
    isSubmittingMFA,
    mfaOptions,
    selectAppointment,
    cancelAppointment,
    submitMFACode,
    cancelMFA,
  } = useTransfer();
  const { notesDetails } = useAppSelector((state) => state.notes);

  const isOnTargetNote = activeJob?.audio_file_id != null && notesDetails?.id === activeJob.audio_file_id;

  // The department picker reuses the appointment modal (awaiting_appointment) —
  // the options are tagged kind:"department" so we can title it correctly.
  const isDepartmentSelection = appointmentOptions?.some((o) => o.kind === "department") ?? false;

  const modalTitle = isNoteTypeSelection
    ? "Select Note Template"
    : isDepartmentSelection
      ? "Select Department"
      : undefined;
  const modalDescription = isNoteTypeSelection
    ? "Multiple note templates are available. Please select the template to use for this note:"
    : isDepartmentSelection
      ? "Please select the department to write this note into:"
      : undefined;

  return (
    <>
      <AppointmentSelectionModal
        visible={showAppointmentModal && isOnTargetNote}
        appointments={appointmentOptions}
        onSelect={selectAppointment}
        onCancel={cancelAppointment}
        loading={isSelectingAppointment}
        title={modalTitle}
        description={modalDescription}
      />
      <MFACodeModal
        visible={showMFAModal && isOnTargetNote}
        onSubmit={submitMFACode}
        onCancel={cancelMFA}
        loading={isSubmittingMFA}
        mfaOptions={mfaOptions}
      />
    </>
  );
};

export default TransferModalsHost;
